module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-06.db269533.png";